<section id="custom-progress-bar">
  <section class="progress-bar" [ngStyle]="{width: value + '%'}"></section>
</section>
